import { Route, Switch } from "react-router";
import InspectionFormsForm from "./InspectionFormsForm";
import InspectionFormsTable from "./InspectionFormsTable";
import WriteRoute from "../../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route
      exact path="/inspection/inspectionforms/"
      component={InspectionFormsTable}
    />
    <WriteRoute
      path="/inspection/inspectionforms/addnew"
      component={InspectionFormsForm}
      redirectTo="/inspection/inspectionforms/"
    />
  </Switch>
);